import React, { useEffect, useState } from "react";
import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody } from "reactstrap";
import { MdSearch, MdClear } from "react-icons/lib/md";
import { httpClient } from "../../../api/httpClient";
import { urlListarMarcas } from "../api/urls";

/**
 * Componente FiltrosVehiculos.
 *
 * @param {object} props
 * @param {object} props.filtros - Estado actual de los filtros
 * @param {function} props.onChange - Handler cuando cambian los filtros
 * @param {function} props.onLimpiar - Handler para resetear filtros
 */
const FiltrosVehiculos = ({ filtros, onChange, onLimpiar }) => {
  const [marcas, setMarcas] = useState([]);

  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const response = await httpClient.get(urlListarMarcas);
        if (response && response.transaccion !== false && response.marcas) {
          setMarcas(response.marcas);
        }
      } catch (error) {
        console.error("Error al cargar marcas en filtros:", error);
      }
    };
    fetchMarcas();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value);
  };

  return (
    <Card className="mb-4 shadow-sm border-0">
      <CardBody className="py-3">
        <Row className="align-items-end">
          <Col md={4} sm={6} xs={12} className="mb-2 mb-md-0">
            <FormGroup className="mb-0">
              <Label for="filtroPlaca" className="font-weight-bold small text-uppercase text-muted">
                Buscar por Placa
              </Label>
              <Input
                type="text"
                id="filtroPlaca"
                name="placa"
                placeholder="Ej: PBA1234"
                value={filtros.placa}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
          <Col md={4} sm={6} xs={12} className="mb-2 mb-md-0">
            <FormGroup className="mb-0">
              <Label for="filtroMarca" className="font-weight-bold small text-uppercase text-muted">
                Filtrar por Marca
              </Label>
              <Input
                type="select"
                id="filtroMarca"
                name="marca"
                value={filtros.marca}
                onChange={handleChange}
              >
                <option value="">Todas las marcas</option>
                {marcas.map((marca) => (
                  <option key={marca.marCodigoCore} value={marca.marNombre}>
                    {marca.marNombre}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={4} sm={12} xs={12} className="text-md-right text-left">
            <Button
              color="secondary"
              outline
              onClick={onLimpiar}
              className="d-inline-flex align-items-center"
            >
              <MdClear className="mr-1" /> Limpiar
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default FiltrosVehiculos;
